import React, { useEffect, useState } from 'react';
import Page1 from './components/PurchaseDistrict';

import { getApmcByDepartmentId, getExistedSchemesAplication, submitApmcFiles } from '../../auth/services/privateapicalling';
// import { getApplicationExistencCheck } from '../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
// import Page2 from './components/Page2';
// import Page3 from './components/Page3';

 
 
// ---------------------------------- IDs ----------------------------------

const DistrictAllForms: React.FC = () => {

 
    const token = useSelector((state:any)=>state.auth.token);
    const userDetail = useSelector((state:any)=>state.auth.userDetails)
    const location = useLocation();
     const [uploadLoading, setUploadLoading]=useState(false);
      const applicationId = location.state?.applicationId;
  const id= location.state?.id;

    const type= location.state?.type || null;
 
  const [existData ,setExistData] = useState<any | null>(null);
  // const [applicationId , setApplicationID] = useState<string | null>(null);
 
    const [transaction , setTransaction] = useState<any[]>([])
  
  const [step, setStep] = useState<number>(1);

 const [formData, setFormData] = useState<Record<string, Array<Record<string, any>>>>({});
 
//  const[updatedFields,setUpdatedFields]=useState({});
  const [editFieldValues, setEditFieldValues] =  useState<Record<string, Array<Record<string, any>>>>({});
  const [editFiles, setEditFiles] =  useState<Record<string, Array<Record<string, any>>>>({});




 const getExistedApplication = async () => {
   try {
      
        const response = await getExistedSchemesAplication(token, applicationId, id);
       
        if (response?.success) {
        
           setExistData(response?.data);
           setTransaction(response?.data?.ApmcSchemeTransaction || []);
        }
      } catch (error) {
       
      }
    }

//----------------------------------FETCH API----------------------------------

   useEffect(()=>{
 
     getExistedApplication();
  },[])

  const handleNext = (): void => {
    if (step < 3) setStep(step + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };
 
  const handleBack = (): void => {
    if (step > 1) setStep(step - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };





// ----------------------------------Handle Inputs----------------------------------


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
 
  const { name, files } = e.target;
  
   if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      // setItReturns((prev) => ({ ...prev, [name]: files[0] }));
      // setDisableButtonNext(true)
      let docId:any;
     const userData= existData?.annexureOne?.[fieldName]?.transaction?.find(data=>data.transactionBy == userDetail.Role.Role_Identifier)

      if(userData)
      {
        
        const docData = userData?.newValue.find(data=>data?.fieldName == name);
       
        docId = docData?.fieldValue ? docData.fieldValue : null;
        
      }
     
      handleUpload(name,file, fieldName ,docId ,fileName);
 
 
      // setDisableButtonNext(false)
    }


    
};

const handleUpload = async (documentName: string,file:any , fieldName:string , docId?: string | null,fileName?:string ) => {
    // if (!formData[fieldName]) return;
 setUploadLoading(true)
    const formData = new FormData();
    formData.append("file", file );
    formData.append("documentName", documentName);
    formData.append("fieldName", fieldName);
    formData.append("applicationId", applicationId);
    formData.append("schemeId",id)
 
 
    try {
      const res = await submitApmcFiles(formData, token, docId);
      
      
      if(res.success===false)
        {
      toast.error(res?.message || "File upload failed", {position: "top-right", autoClose: 3000});
  
      }
      else if (res.success && res.docId) {
  
       setEditFiles(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
     const index = arr.findIndex(item => item.documentName === documentName);
if (index !== -1) {
  arr[index] = { docId: res?.docId, documentName: documentName, fileName: fileName };
} else {
  arr.push({ docId: res?.docId, documentName: documentName, fileName: fileName });
}
      return { ...prev, [fieldName]: arr };
    });
        toast.success("File uploaded successfully", {position: "top-right", autoClose: 3000});
      }
    } catch (error) {
      toast.error("File upload failed");
    } finally{
      setUploadLoading(false)
    }
  };

const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>,fieldName?:string) => {
  const { name, value } = e.target;
 if(fieldName) {
  
   if (fieldName) {
    setEditFieldValues(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
      const index = arr.findIndex(item => item.fieldName === name);
      if (index !== -1) {
        arr[index] = { ...arr[index], value: value };
      } else {
        arr.push({ value: value, fieldName: name });
      }
      return { ...prev, [fieldName]: arr };
    });
  } else {
    // Optionally handle case when fieldName is not provided
  }
 
  }
 
};


  useEffect(() => {
// getExistedApplication();
    // fetchApplicationExistenceCheck();

  }
  ,[step])
 
  return (
         
  <div className="page-wrapper ">
  

  {/* Step Form Display (scrollable content) */}
  {step === 1 && existData&&(
    <Page1
      onNext={handleNext}
        editFieldValues={editFieldValues}
        setEditFieldValues={setEditFieldValues}
      editFiles={editFiles}
       setEditFiles={setEditFiles}
      onBack={handleBack}
      formData={formData}
      setFormData={setFormData}
      handleFileChange={handleFileChange}
      handleInputChange={handleInputChange}
      type={id}
      existData={existData}
      applicationId={applicationId}
      formType={type}
      transaction={transaction}
      getExistedApplication={getExistedApplication}
      uploadLoading={uploadLoading}
    />
  )}

  {/* <ToastContainer  autoClose={3000}/> */}
</div>
  );
};
 
export default DistrictAllForms;
